import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommunicationDto} from '../../../../Models/Communication/communication.interface';
import {TaskTypesEnum} from '../../../../Shared/Enum/task-types.enum';
import {CommunicationTypesEnum} from '../../../../Shared/Enum/communication-types.enum';

@Component({
  selector: 'app-communication-data-block',
  templateUrl: './communication-data-block.component.html',
  styleUrls: ['./communication-data-block.component.scss'],
  standalone: false
})
export class CommunicationDataBlockComponent {
  @Input() communication!: CommunicationDto;
  @Output() shareButton: EventEmitter<void> = new EventEmitter<void>();

  taskTypesEnum = TaskTypesEnum;
  communicationTypesEnum = CommunicationTypesEnum;
}
